import { addDays, parse, startOfDay } from "date-fns";

export type EventSection<T> = { title: string; data: T[] };

export function groupEventsByDate<T extends { date?: string | null }>(
  events: T[] | null
): EventSection<T>[] {
  if (!events || events.length === 0) return [];

  const now = new Date();
  const todayStart = startOfDay(now);
  const tomorrowStart = addDays(todayStart, 1);
  const nextWeekStart = addDays(todayStart, 7);

  const today: T[] = [];
  const thisWeek: T[] = [];
  const upcoming: T[] = [];
  const past: T[] = [];

  for (const event of events) {
    const eventDate = parse(event.date ?? "", "yyyy-MM-dd", new Date());
    if (eventDate < todayStart) {
      past.push(event);
    } else if (eventDate < tomorrowStart) {
      today.push(event);
    } else if (eventDate < nextWeekStart) {
      thisWeek.push(event);
    } else {
      upcoming.push(event);
    }
  }

  past.reverse();

  const sections: EventSection<T>[] = [];
  if (today.length > 0) sections.push({ title: "Today", data: today });
  if (thisWeek.length > 0)
    sections.push({ title: "This Week", data: thisWeek });
  if (upcoming.length > 0) sections.push({ title: "Upcoming", data: upcoming });
  if (past.length > 0) sections.push({ title: "Past", data: past });

  return sections;
}
